import { getToken } from './authService';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Submit dhaba registration
export async function submitDhabaRegistration(data) {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const response = await fetch(`${API_URL}/api/registrations/submit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    let errorMsg = 'Failed to submit registration';
    try {
      const error = await response.json();
      errorMsg = error.detail || errorMsg;
    } catch {
      const text = await response.text();
      errorMsg = text || errorMsg;
    }
    throw new Error(errorMsg);
  }
  
  return response.json();
}

// Get my submissions
export async function getMySubmissions() {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const response = await fetch(`${API_URL}/api/registrations/my-submissions`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get submissions');
  }
  
  return response.json();
}

// Admin: Get pending registrations
export async function getPendingRegistrations() {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const response = await fetch(`${API_URL}/api/registrations/pending`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to get pending registrations');
  }
  
  return response.json();
}

// Admin: Approve registration
export async function approveRegistration(dhabaId, adminUpdate = null) {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const url = new URL(`${API_URL}/api/registrations/${dhabaId}/approve`);
  
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: adminUpdate ? JSON.stringify(adminUpdate) : null,
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to approve registration');
  }
  
  return response.json();
}

// Admin: Reject registration
export async function rejectRegistration(dhabaId, reason) {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const url = new URL(`${API_URL}/api/registrations/${dhabaId}/reject`);
  url.searchParams.append('reason', reason);
  
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to reject registration');
  }
  
  return response.json();
}

// Admin: Update dhaba (admin fields only)
export async function adminUpdateDhaba(dhabaId, update) {
  const token = getToken();
  if (!token) throw new Error('Not authenticated');
  
  const response = await fetch(`${API_URL}/api/registrations/${dhabaId}/admin-update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(update),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update dhaba');
  }
  
  return response.json();
}
